<template>
  <div class="top-quantity">
    <div class="title-section">
      <img src="@/assets/gisWork/SVG/title-bg.svg" class="title-bg" />
      <span class="title-text">数量统计</span>
    </div>

    <!-- 数量统计卡片 -->
    <div class="quantity-wrapper">
      <button class="nav-btn nav-left" @click="scrollLeft" aria-label="left">
        <img class="nav-icon" src="@/assets/gisWork/SVG/arrow.svg" alt="left" />
      </button>
      <div class="cards-container" ref="cardsContainer">
        <div class="cards">
          <div class="card" v-for="(item, idx) in statistics" :key="idx">
            <div class="content">
              <div class="value">{{ item.value }}</div>
              <div class="label">{{ item.label }}</div>
            </div>
            <div class="icon">
              <img :src="item.img" class="icon-inner" :alt="item.label" />
            </div>
          </div>
        </div>
      </div>
      <button class="nav-btn nav-right" @click="scrollRight" aria-label="right">
        <img class="nav-icon flip" src="@/assets/gisWork/SVG/arrow.svg" alt="right" />
      </button>
    </div>
  </div>
</template>



<script>
export default {
  name: 'TopQuantity',
  data () {
    return {
      featureUrl: '/pipe-network/gis/pipe-networks/workbench/feature-point',
      statistics: [
        { value: 0, label: '大用户表', img: require('@/assets/gisWork/SVG/large-user-table.svg') },
        { value: 0, label: '用户水表', img: require('@/assets/gisWork/SVG/user.svg') },
        { value: 0, label: '水表井', img: require('@/assets/gisWork/SVG/water-meter-well.svg') },
        { value: 0, label: '阀门井', img: require('@/assets/gisWork/SVG/valve-valve-well.svg') },
        { value: 0, label: '消防栓', img: require('@/assets/gisWork/SVG/fire-hydrant.svg') },
        { value: 0, label: '加压泵站', img: require('@/assets/gisWork/SVG/pressurized-pumping-station.svg') },
        { value: 0, label: '排气阀', img: require('@/assets/gisWork/SVG/air-exhaust-valve.svg') },
        { value: 0, label: '压力表', img: require('@/assets/gisWork/SVG/pressure-gauge.svg') },
        { value: 0, label: '减压阀', img: require('@/assets/gisWork/SVG/pressure-reducing-valve.svg') },
        { value: 0, label: '排水阀', img: require('@/assets/gisWork/SVG/drain-off-valve.svg') },
        { value: 0, label: '预留口', img: require('@/assets/gisWork/SVG/reserved-port.svg') },
      ]
    }
  },
  mounted () {
    this.fetchStatisticsData()
  },
  methods: {
    async fetchStatisticsData () {
      try {
        const response = await this.$http.get(this.featureUrl)
        const apiData = response.data

        // 根据featurePoint匹配statistics中的label，更新value
        this.statistics.forEach(item => {
          const matchedData = apiData.find(apiItem => apiItem.featurePoint === item.label)
          if (matchedData) {
            item.value = parseInt(matchedData.num)
          }
        })
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },
    scrollLeft () {
      const el = this.$refs.cardsContainer
      if (el) el.scrollBy({ left: -1150, behavior: 'smooth' })
    },
    scrollRight () {
      const el = this.$refs.cardsContainer
      if (el) el.scrollBy({ left: 750, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="less" scoped>
.top-quantity {
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  background-color: white;
}

.title-section {
  position: relative;
  display: inline-block;

  .title-bg {
    width: 250px;
    height: 50px;
    object-fit: contain;
  }

  .title-text {
    position: absolute;
    top: 47%;
    left: 27%;
    transform: translate(-50%, -50%);
    color: #093d97;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    z-index: 2;
  }
}

/* 数量卡片区域 */
.quantity-wrapper {
  position: relative;
  margin-top: 10px;
}

.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 72px;
  border: none;
  background: transparent;
  cursor: pointer;
  z-index: 2;
  padding: 0;
}

.nav-icon {
  width: 32px;
  height: 72px;
  object-fit: contain;
}

.flip {
  transform: scaleX(-1);
}

.nav-left {
  left: -6px;
}

.nav-right {
  right: -6px;
}

.cards-container {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2px 6px;
  scroll-behavior: smooth;
  width: 95%;
  margin: 0 auto;
}

.cards-container::-webkit-scrollbar {
  height: 0;
}

.cards {
  margin-left: 0;
  display: flex;
  gap: 26px;
  min-width: max-content;
}

.card {
  width: 190px;
  height: 80px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(217, 217, 217, 0.996078431372549);
  padding: 14px 16px;
  display: flex;
  align-items: center;
}

.icon {
  width: 70px;
  height: 70px;
  display: grid;
  place-items: center;
}

.icon-inner {
  width: 60px;
  height: 60px;
  object-fit: contain;
}


.content {
  width: 60%;
}

.content .value {
  color: #1a73e8;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 6px;
}

.content .label {
  color: #777;
  font-size: 12px;
}
</style>